import * as types from './articleActionTypes';

const initialState = {
    showComment: false,
    showBlockedCommentPopup: false,
    emoReactionAdded : false,
    emoReactionInProgress : false,
    reactionsRetrieved : false,
    reactionsInProgress : false,
    totalReactionsByArticles : [],
    articleRetrieved : false,
    articleRetrievalInProgress : false,
    currentArticle : {},
    currentUserArticleReaction : 0,
    userReactionRetrieved : false,
    userReactionInProgress : false,
    errorMessage : '',
    errorCode : ''
};

const showComment = (state, action) => {
    return {
        ...state,
        showComment: true
    }
};

const hideComment = (state, action) => {
    return {
        ...state,
        showComment: false
    }
};

const showBlockedCommentPopup = (state, action) => {
    return {
        ...state,
        showBlockedCommentPopup: true
    }
}

const hideBlockedCommentPopup = (state, action) => {
    return {
        ...state,
        showBlockedCommentPopup: false
    }
}

const addEmoReactionSuccess = (state, action) => {
    const { reactionId } = action;
    return {
        ...state,
        emoReactionAdded : true,
        currentUserArticleReaction: reactionId
    }
}

const addEmoReactionFail = (state, action) => {
    return {
        ...state,
        errorMessage : action.errorMessage,
        errorCode : action.errorCode
    }
}

const addEmoReactionStart = (state, action) => {
    return {
        ...state,
        emoReactionInProgress : true,
    }
}

const getAllArticleReactionsSuccess = (state, action) => {
    return {
        ...state,
        reactionsRetrieved : true,
        totalReactionsByArticles : action.totalReactions
    }
}

const getAllArticleReactionsFail = (state, action) => {
    return {
        ...state,
        errorMessage : action.errorMessage,
        errorCode : action.errorCode
    }
}

const getAllArticleReactionsStart = (state, action) => {
    return {
        ...state,
        reactionsInProgress : true,
    }
}

const getAllArticleContentSuccess = (state, action) => {
    return {
        ...state,
        articleRetrieved : true,
        articleRetrievalInProgress : false,
        currentArticle : action.articleContent
    }
}

const getAllArticleContentFail = (state, action) => {
    return {
        ...state,
        errorMessage : action.errorMessage,
        errorCode : action.errorCode
    }
}

const getAllArticleContentStart = (state, action) => {
    return {
        ...state,
        articleRetrievalInProgress : true,
    }
}

const getArticleEmoReactionSuccess = (state, action) => {
    return {
        ...state,
        userReactionRetrieved : true,
        currentUserArticleReaction : action.userArticleReaction
    }
}

const getArticleEmoReactionFail = (state, action) => {
    return {
        ...state,
        errorMessage : action.errorMessage,
        errorCode : action.errorCode
    }
}

const getArticleEmoReactionStart = (state, action) => {
    return {
        ...state,
        userReactionInProgress : true,
    }
}

export const article = (state = initialState, action) => {
    switch(action.type) {
        case types.SHOW_COMMENT:  return showComment(state, action);
        case types.HIDE_COMMENT:  return hideComment(state, action);

        case types.SHOW_BLOCKED_COMMENT_POPUP: return showBlockedCommentPopup(state, action);
        case types.HIDE_BLOCKED_COMMENT_POPUP: return hideBlockedCommentPopup(state, action);
        
        case types.EMO_REACTION_START : return addEmoReactionStart(state, action);
        case types.EMO_REACTION_SUCCESS : return addEmoReactionSuccess(state, action);
        case types.EMO_REACTION_FAIL : return addEmoReactionFail(state, action);

        case types.RETRIEVE_ARTICLE_REACTIONS_START : return getAllArticleReactionsStart(state, action);
        case types.RETRIEVE_ARTICLE_REACTIONS_SUCCESS : return getAllArticleReactionsSuccess(state, action);
        case types.RETRIEVE_ARTICLE_REACTIONS_FAIL : return getAllArticleReactionsFail(state, action);        

        case types.RETRIEVE_ARTICLE_CONTENT_START : return getAllArticleContentStart(state, action);
        case types.RETRIEVE_FAKE_ARTICLE_CONTENT_SUCCESS:
        case types.RETRIEVE_ARTICLE_CONTENT_SUCCESS : return getAllArticleContentSuccess(state, action);
        case types.RETRIEVE_ARTICLE_CONTENT_FAIL : return getAllArticleContentFail(state, action); 

        case types.RETRIEVE_ARTICLE_EMO_REACTION_START : return getArticleEmoReactionStart(state, action);
        case types.RETRIEVE_ARTICLE_EMO_REACTION_SUCCESS : return getArticleEmoReactionSuccess(state, action);
        case types.RETRIEVE_ARTICLE_EMO_REACTION_FAIL : return getArticleEmoReactionFail(state, action); 

        default: return state;
    }
}

export default article;


// WEBPACK FOOTER //
// ./src/components/Article/articleReducers.js